exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-home-page-template-tsx": () => import("./../../../src/templates/HomePageTemplate.tsx" /* webpackChunkName: "component---src-templates-home-page-template-tsx" */)
}

